export class HostingDomainData {
  adminUrl: string;
  cfEnabled: boolean;
  createdAt: string;
  default: number;
  domainId: number;
  id: number;
  name: string;
  domain_name: string;
  OGname: string;
  scheme: string;
  siteUrl: string;
  updatedAt: string;
  httpsEnabled: number;
  zone: any;
  isConnected: any;
  connectedWebsiteId: any;
  domainPointed?: boolean;
  hasCertificate?: number;
  hasIpv6?: boolean;
  server?: string;
  tenWebCf?: boolean;
  tenWebDomain?: boolean;
  tenWebIp?: boolean;
  tenWebNs?: boolean;
  verificationNeeded?: boolean;
  pending?: boolean;
}

